import { z } from 'zod';
import { MIN_PASSWORD_LENGTH } from '../../domain/constants';

const EMAIL_MAX_LENGTH = 320;
const MAX_PASSWORD_LENGTH = 128;
const LOWERCASE_REGEX = /[a-z]/;
const UPPERCASE_REGEX = /[A-Z]/;
const DIGIT_REGEX = /[0-9]/;
const SPECIAL_CHAR_REGEX = /[^a-zA-Z0-9]/;

export const signInSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z
    .string()
    .min(MIN_PASSWORD_LENGTH, `Password must be at least ${MIN_PASSWORD_LENGTH} characters`),
});

export type SignInSchema = z.infer<typeof signInSchema>;

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .email('Please enter a valid email address.')
    .min(1, 'Email address is required.')
    .max(EMAIL_MAX_LENGTH, 'Email address is too long.'),
});

export type ForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(MIN_PASSWORD_LENGTH, `Password must be at least ${MIN_PASSWORD_LENGTH} characters long.`)
      .max(MAX_PASSWORD_LENGTH, `Password must be less than ${MAX_PASSWORD_LENGTH} characters.`)
      .regex(LOWERCASE_REGEX, 'Password must contain at least one lowercase letter.')
      .regex(UPPERCASE_REGEX, 'Password must contain at least one uppercase letter.')
      .regex(DIGIT_REGEX, 'Password must contain at least one number.')
      .regex(SPECIAL_CHAR_REGEX, 'Password must contain at least one special character.'),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });

export type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>;
